import { Spinner } from '@change/ds-core-ui';

import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';
import { useKnownAvailableParams } from '@change-corgi/core-react/router';

import I18N_PLACEHOLDERS from 'config/i18n/placeholders/petitionGamma/petition-gamma.yml';

import type { PetitionDetailsPagePrefetchedDataProps } from 'src/app/pages/petitionDetails/pageContext';
import { PetitionDetailsPageContextProvider } from 'src/app/pages/petitionDetails/pageContext';

import { DetailsWithContext } from './DetailsWithContext';
import { PetitionDetailsErrorHandler } from './ErrorHandler';

export const CommonPetitionDetails = withI18nPlaceholders(
	I18N_PLACEHOLDERS,
	function CommonPetitionDetails({ prefetchedData, prefetchedUserData }: PetitionDetailsPagePrefetchedDataProps) {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<div data-qa="petition-gamma">
				<PetitionDetailsPageContextProvider
					slug={slug}
					prefetchedData={prefetchedData}
					prefetchedUserData={prefetchedUserData}
					errorHandler={PetitionDetailsErrorHandler}
					loadingFallback={<Spinner className="mx-auto my-64" />}
				>
					<DetailsWithContext slug={slug} />
				</PetitionDetailsPageContextProvider>
			</div>
		);
	},
);
